<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark"> <!-- bg-dark -->
        <div class="container-fluid">
<!--            <a class="navbar-brand" href="/">Exikovo</a>-->
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
          <div class="navbar-brand" >
            <span @click="goBack" v-if="showArrow()">&larr;</span>
            <span v-if="!showArrow()">&nbsp;</span>
          </div>
            <div class="collapse navbar-collapse ml-auto" id="navbarNav">
                <ul class="navbar-nav ml-auto">
                    <slot></slot>
                </ul>
                <div v-if="center" class="navbar-nav ml-auto"></div>
            </div>
        </div>
    </nav>
</template>

<script>
    export default {
        name: "NavBar",
        props: {
            center: {required: false, type: Boolean, default: false}
        },
        methods: {
            goBack: function () {
                this.$router.back();
            },
            showArrow: function () {
                // console.log(this.$route.path !="/");
                return this.$route.path !="/";
            }
        }
    }
</script>

<style scoped>

</style>